// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyDF5CvjeZlz4ux9q1v4dnSnAi2a-YNrGaw",
  authDomain: "loupgarou-fff93.firebaseapp.com",
  projectId: "loupgarou-fff93",
  storageBucket: "loupgarou-fff93.firebasestorage.app",
  messagingSenderId: "1023303886708",
  appId: "1:1023303886708:web:07e72c093ff9ebb4822e21",
  measurementId: "G-D12Q6W8K7C"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);
export default app;